// extracted by mini-css-extract-plugin
export var first = "styles-module--first--cf2f6";
export var line = "styles-module--line--b68ff";
export var lineWhite = "styles-module--lineWhite--47a63";
export var opened = "styles-module--opened--44ce6";
export var second = "styles-module--second--2f37c";
export var third = "styles-module--third--727ad";
export var wrapper = "styles-module--wrapper--917b2";